import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// We import all translations here for simplicity, though they can be lazy-loaded
import en from './locales/en/translation.json';
import ar from './locales/ar/translation.json';
import zhCN from './locales/zh-CN/translation.json';
import nl from './locales/nl/translation.json';
import fr from './locales/fr/translation.json';
import de from './locales/de/translation.json';
import it from './locales/it/translation.json';
import pt from './locales/pt/translation.json';
import ru from './locales/ru/translation.json';
import es from './locales/es/translation.json';
import id from './locales/id/translation.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  'zh-CN': { translation: zhCN },
  nl: { translation: nl },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt },
  ru: { translation: ru },
  es: { translation: es },
  id: { translation: id }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
